import { render } from "./ContactForm.vue?vue&type=template&id=741ffc0e&scoped=true&ts=true"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"

import "./ContactForm.vue?vue&type=style&index=0&id=741ffc0e&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\151\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741ffc0e"]])

export default __exports__